import FroalaEditor from 'froala-editor';

// The custom popup is defined inside a plugin (new or existing).
FroalaEditor.PLUGINS.confirmOnLeavePlugin = function (editor) {
  const onEditorIsBusyChange = editor.opts.onEditorIsBusyChange;
  let pendingUploads = 0;

  function beforeImageUpload(images) {
    pendingUploads += images.length;
    updateIsBusy();
  }

  function afterImageUpload() {
    pendingUploads -= 1;
    updateIsBusy();
  }

  function updateIsBusy() {
    if (onEditorIsBusyChange) {
      onEditorIsBusyChange(pendingUploads > 0);
    }
  }

  // eslint-disable-next-line no-underscore-dangle
  function _init() {
    if (editor.opts.onEditorIsBusyChange) {
      editor.events.on('image.beforeUpload', beforeImageUpload);
      editor.events.on('video.beforeUpload', beforeImageUpload);
      editor.events.on('image.inserted', afterImageUpload);
      editor.events.on('image.replaced', afterImageUpload);
      editor.events.on('video.inserted', afterImageUpload);
      editor.events.on('video.codeError', afterImageUpload);
      editor.events.on('video.linkError', afterImageUpload);
    }
  }

  // Methods visible outside the plugin.
  return {_init};
};
